if (!customElements.get('product-upsell-block')) {
  customElements.define(
    'product-upsell-block',
    class ProductUpsellBlock extends HTMLElement {
      connectedCallback() {
        const dataEl = this.querySelector('script.product-upsell-block__variants');
        if (!dataEl) return;

        try {
          this.data = JSON.parse(dataEl.textContent);
        } catch (e) {
          console.error('product-upsell-block: failed to parse variant data', e);
          return;
        }

        this.checkbox = this.querySelector('.product-upsell-block__checkbox');
        this.priceEl = this.querySelector('.product-upsell-block__price-value');
        this.compareEl = this.querySelector('.product-upsell-block__compare');
        this.discountEl = this.querySelector('.product-upsell-block__discount');
        this.unavailableEl = this.querySelector('.product-upsell-block__unavailable');
        this.imageEl = this.querySelector('.product-upsell-block__image');
        this.upsellSizeIndex = parseInt(this.dataset.upsellSizeIndex, 10);
        this.parentSizeIndex = parseInt(this.dataset.parentSizeIndex, 10);
        this.upsellColorIndex = parseInt(this.dataset.upsellColorIndex, 10);
        this.parentColorIndex = parseInt(this.dataset.parentColorIndex, 10);
        this.sectionId = this.dataset.sectionId;

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event?.data || event.data.sectionId !== this.sectionId) return;
          this.onParentVariantChange(event.data.variant);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      onParentVariantChange(parentVariant) {
        if (!parentVariant || this.parentSizeIndex < 0 || this.upsellSizeIndex < 0) return;

        const parentSize = parentVariant.options?.[this.parentSizeIndex];
        if (parentSize == null) return;

        // Match color too when both products have a Color option, so the insurance
        // variant follows the shopper's color selection instead of defaulting to the first.
        const matchColor = this.upsellColorIndex >= 0 && this.parentColorIndex >= 0;
        const parentColor = matchColor ? parentVariant.options?.[this.parentColorIndex] : null;

        const match = this.data.variants.find((v) => {
          if (v.options?.[this.upsellSizeIndex] !== parentSize) return false;
          if (matchColor && v.options?.[this.upsellColorIndex] !== parentColor) return false;
          return true;
        });
        this.applyVariant(match);
      }

      applyVariant(variant) {
        if (!this.checkbox) return;

        if (!variant || !variant.available) {
          this.checkbox.checked = false;
          this.checkbox.disabled = true;
          this.classList.add('is-unavailable');
          if (this.unavailableEl) this.unavailableEl.hidden = false;
          return;
        }

        this.checkbox.disabled = false;
        this.checkbox.value = String(variant.id);
        this.checkbox.dataset.upsellVariantId = String(variant.id);
        this.classList.remove('is-unavailable');
        if (this.unavailableEl) this.unavailableEl.hidden = true;
        if (this.priceEl && variant.price) this.priceEl.textContent = variant.price;

        // Swap the thumbnail to the matched variant's image so it follows the
        // shopper's colour selection (e.g. Pink main product -> pink single shoe).
        if (this.imageEl && variant.image) {
          this.imageEl.removeAttribute('srcset');
          this.imageEl.src = variant.image;
        }

        if (this.compareEl) {
          if (variant.compare_at_price_money) {
            this.compareEl.textContent = variant.compare_at_price_money;
            this.compareEl.hidden = false;
          } else {
            this.compareEl.textContent = '';
            this.compareEl.hidden = true;
          }
        }

        if (this.discountEl) {
          if (variant.discount_percent != null) {
            this.discountEl.textContent = `-${variant.discount_percent}%`;
            this.discountEl.hidden = false;
          } else {
            this.discountEl.textContent = '';
            this.discountEl.hidden = true;
          }
        }
      }
    }
  );
}
